module.exports = __webpack_public_path__ + "static/media/nynfc_logo.488e7e52.png";